import { mockBuilder } from '../../utils/builderHelper.es.js';
import { aPrice } from '../Price.mock.es.js';
import { PaymentMigration } from './PaymentMigration.es.js';

/** @module Mocks */ /** typedoc */
function aPaymentMigration() {
    return mockBuilder(new PaymentMigration())
        .withCanMigrate(true)
        .withToken('mock-token-id')
        .withOld(aPrice().withValue(100.0).withCurrencyCode('SEK').withCurrencySymbol('kr'))
        .withNew(aPrice().withValue(11.57).withCurrencyCode('USD').withCurrencySymbol('$'));
}
function aPaymentMigrationWithNoCurrencyChange() {
    return mockBuilder(new PaymentMigration())
        .withCanMigrate(true)
        .withOld(aPrice().withValue(100.0).withCurrencyCode('SEK').withCurrencySymbol('kr'));
}

export { aPaymentMigration, aPaymentMigrationWithNoCurrencyChange };
